import validator from 'validator';

const validateCreateBanner = (data) => {
    let errors = {};
    let url_regex = '((https)://)(www.)?[a-zA-Z0-9@:%._\\+~#?&//=]{2,256}\\.[a-z]{2,6}\\b([-a-zA-Z0-9@:%._\\+~#?&//=]*)';

    const { title, file, redirection_url } = data;

    if (validator.isEmpty(title)) {
        errors.title = '제목을 입력해주세요';
    }
    if (validator.isEmpty(file)) {
        errors.file = '파일을 업로드 해주세요';
    }
    if (validator.isEmpty(redirection_url)) {
        errors.redirection_url = '유효한 주소를 입력해 주세요';
    } else if (!validator.isURL(redirection_url)) {
        errors.redirection_url = 'URL을 입력해주세요';
    } else if (!redirection_url.match(url_regex)) {
        errors.redirection_url = '유효한 URL 주소를 입력해 주세요.';
    }
    // if(validator.isURL(redirection_url)){
    //     errors.redirection_url = "Invalid URL"
    // }
    return {
        isInvalid: Object.keys(errors).length > 0,
        error: errors,
    };
};

export default validateCreateBanner;
